// permissions.middleware.js
export const checkPermissions = (userPermissions, requiredPermissions) => {
  // Check if the user has all the required permissions
  return requiredPermissions?.every((permission) =>
    userPermissions?.includes(permission)
  );
};
